import React, { Component } from "react";

import { Link } from "react-router-dom";

import { Element } from "react-scroll";

export default class Lojas extends Component {
  render() {
    return (
      <section id="lojas">
        <Element name="lojasElement" />
        <h1>Lojas</h1>

        <div className="section-background">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-9 col-lg-7">
                <p className="background-texto-principal">
                  Leve para casa os melhores produtos da nossa aldeia.
                </p>

                <div className="bottom-align-background" >
                  <p className="background-texto-secundario">
                  Escolha entre o famoso queijo da Serra da Estrela, os enchidos deliciosos, umas pantufas quentinhas ou um de muitos outros artigos que a nossa aldeia oferece.
                  </p>
                  <Link to="/lojas">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-above-image"
                    >
                      <span>Lojas ao seu dispor</span>
                    </button>
                  </Link>
                </div>

                
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
